import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { setAuth } from "../lib/auth";
import { Shield, LogIn, UserPlus } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (mode === "login") {
        const r = await api.post("/auth/login", { email, password });
        setAuth(r.data.token, {
          id: r.data.user_id, email: r.data.email, role: r.data.role,
          name: r.data.name, picture: r.data.picture,
        });
        toast.success("Login berhasil");
        navigate(r.data.role === "admin" ? "/admin" : "/");
      } else {
        const r = await api.post("/auth/register", { name, email, password });
        setAuth(r.data.token, r.data.user);
        toast.success("Akun berhasil dibuat. Selamat datang!");
        navigate("/");
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || (mode === "login" ? "Login gagal" : "Registrasi gagal"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-24 relative z-10">
      <div className="card p-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-cyan1 to-magenta1 flex items-center justify-center">
            <Shield className="w-5 h-5 text-void" strokeWidth={3} />
          </div>
          <div>
            <h1 className="font-heading text-2xl font-bold">{mode === "login" ? "Masuk" : "Daftar Akun"}</h1>
            <p className="text-slate-500 text-sm">Komentar, bookmark &amp; newsletter NOXAI</p>
          </div>
        </div>

        <div className="flex gap-2 mb-6">
          <button onClick={() => setMode("login")} className={`btn-ghost flex-1 justify-center ${mode === "login" ? "!border-cyan1 !text-cyan1" : ""}`} data-testid="tab-login">Masuk</button>
          <button onClick={() => setMode("register")} className={`btn-ghost flex-1 justify-center ${mode === "register" ? "!border-magenta1 !text-magenta1" : ""}`} data-testid="tab-register">Daftar</button>
        </div>

        <button onClick={googleLogin} className="w-full flex items-center justify-center gap-3 bg-white text-gray-800 rounded-lg h-11 font-medium hover:bg-gray-100 transition mb-4" data-testid="google-login-btn">
          <svg className="w-5 h-5" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
          Masuk dengan Google
        </button>

        <div className="flex items-center gap-3 mb-4">
          <div className="flex-1 h-px bg-white/10" />
          <span className="text-slate-600 text-xs font-mono">ATAU</span>
          <div className="flex-1 h-px bg-white/10" />
        </div>

        <form onSubmit={submit} className="space-y-4">
          {mode === "register" && (
            <div>
              <label className="text-xs font-mono uppercase tracking-widest text-slate-500">Nama</label>
              <input value={name} onChange={(e) => setName(e.target.value)} className="mt-1 w-full bg-void border border-white/10 rounded-lg h-11 px-3 focus:border-cyan1/50 outline-none" required data-testid="register-name" />
            </div>
          )}
          <div>
            <label className="text-xs font-mono uppercase tracking-widest text-slate-500">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full bg-void border border-white/10 rounded-lg h-11 px-3 focus:border-cyan1/50 outline-none" required data-testid="login-email" />
          </div>
          <div>
            <label className="text-xs font-mono uppercase tracking-widest text-slate-500">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} minLength={mode === "register" ? 8 : undefined} className="mt-1 w-full bg-void border border-white/10 rounded-lg h-11 px-3 focus:border-cyan1/50 outline-none" required data-testid="login-password" />
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="login-submit">
            {mode === "login" ? <LogIn className="w-4 h-4" /> : <UserPlus className="w-4 h-4" />}
            {loading ? "Memproses..." : mode === "login" ? "Masuk" : "Daftar"}
          </button>
        </form>
      </div>
    </div>
  );
}
